import { store } from 'config/redux'
import moment from 'moment'
import { strings } from 'context/LanguageContext/strings'

const alcoholRestrictedItems = ['beer', 'wine', 'alcohol', 'abv_under_51', 'liquor']

export const alcoholUtility = {
    isAlcohol: product => !!product?.meta_tags?.some(item => alcoholRestrictedItems.includes(item)),

    isAlcoholCategory: category =>
        !!category?.meta_tags?.some(item => alcoholRestrictedItems.includes(item)),

    isBeer: product => !!(product && product.meta_tags && product.meta_tags.includes('beer')),

    isWine: product => !!(product && product.meta_tags && product.meta_tags.includes('wine')),

    isAlcoholRestricted(product) {
        if (this.isAlcohol(product) && this.isAlcoholRestrictedForArea()) return true
        return false
    },

    isRestrictedTime(product) {
        if (this.isAlcohol(product) && this.isAlcoholRestrictedTime()) return true
        return false
    },

    isAlcoholRestrictedForArea() {
        const { location } = store.getState()
        const restrictions = location.toJS().alcoholRestrictions

        if (restrictions) {
            if (
                restrictions.alcohol_blacklisted_address ||
                (restrictions.beer_off_premises &&
                    restrictions.beer_off_premises.toLowerCase() !== 'authorized') ||
                (restrictions.beer_off_premises &&
                    restrictions.wine_off_premises.toLowerCase() !== 'authorized')
            )
                return true
        }

        return false
    },

    isAlcoholRestrictedTime() {
        const { location } = store.getState()
        const { selectedStore } = location.toJS()
        const honoluluOffset = -10 * 60

        if (!selectedStore || selectedStore.alcohol_restriction == null) return false

        const alcoholRestrictions = selectedStore.alcohol_restriction
        const timeList = alcoholRestrictions.time
        const currentTime = moment().utcOffset(honoluluOffset).valueOf()
        const date = moment().utcOffset(honoluluOffset)
        if (timeList === null || timeList === undefined || (timeList && timeList.length === 0)) {
            return false
        }

        for (let i = 0; i < timeList.length; i++) {
            const timeSlot = timeList[i]
            if (timeSlot.day === date.format('dddd')) {
                let alcoholRestricted = false
                const saleHours = timeSlot.sale_hours
                for (let j = 0; j < saleHours.length; j++) {
                    const startTime = moment().utcOffset(honoluluOffset)
                    startTime.set({
                        hour: parseInt(saleHours[j].start_time.substr(0, 2), 10),
                        minute: parseInt(saleHours[j].start_time.substr(2, 4), 10),
                    })
                    const endTime = moment().utcOffset(honoluluOffset)
                    endTime.set({
                        hour: parseInt(saleHours[j].end_time.substr(0, 2), 10),
                        minute: parseInt(saleHours[j].end_time.substr(2, 4), 10),
                    })

                    if (currentTime < startTime.valueOf() || currentTime > endTime.valueOf())
                        alcoholRestricted = true
                    else return false
                }

                return alcoholRestricted
            }
        }

        return false
    },

    getAlcoholAvailableTimings() {
        const { location } = store.getState()
        const { selectedStore } = location.toJS()
        // return (
        //     'Alcohol is available for purchase during the following times in your area\n\n' +
        //     'Monday to Friday – 7am to midnight\n' +
        //     'Saturday – 7am to 1am\n' +
        //     'Sunday – Noon to midnight'
        // )

        if (selectedStore == null || selectedStore.alcohol_restriction == null) return false

        const alcoholRestrictions = selectedStore.alcohol_restriction
        const { time } = alcoholRestrictions

        if (time != null && time.length === 7) {
            const mondayTimings = alcoholUtility.saleHoursToString(time[0])
            const tuesdayTimings = alcoholUtility.saleHoursToString(time[1])
            const wednesdayTimings = alcoholUtility.saleHoursToString(time[2])
            const thursdayTimings = alcoholUtility.saleHoursToString(time[3])
            const fridayTimings = alcoholUtility.saleHoursToString(time[4])
            const saturdayTimings = alcoholUtility.saleHoursToString(time[5])
            const sundayTimings = alcoholUtility.saleHoursToString(time[6])
            const timeArray = []

            if (mondayTimings === tuesdayTimings) {
                if (tuesdayTimings === wednesdayTimings) {
                    if (wednesdayTimings === thursdayTimings) {
                        if (thursdayTimings === fridayTimings) {
                            timeArray.push(`${strings.montofri} — ${mondayTimings}`)
                        } else {
                            timeArray.push(`${strings.montothu} — ${mondayTimings}`)
                            timeArray.push(`${strings.friday} — ${fridayTimings}`)
                        }
                    } else {
                        timeArray.push(`${strings.montowed} — ${mondayTimings}`)
                        timeArray.push(`${strings.thursday} — ${thursdayTimings}`)
                        timeArray.push(`${strings.friday} — ${fridayTimings}`)
                    }
                } else {
                    timeArray.push(`${strings.montotue} — ${mondayTimings}`)
                    timeArray.push(`${strings.wednesday} — ${wednesdayTimings}`)
                    timeArray.push(`${strings.thursday} — ${thursdayTimings}`)
                    timeArray.push(`${strings.friday} — ${fridayTimings}`)
                }
            } else {
                timeArray.push(`${strings.monday} — ${mondayTimings}`)
                timeArray.push(`${strings.tuesday} — ${tuesdayTimings}`)
                timeArray.push(`${strings.wednesday} — ${wednesdayTimings}`)
                timeArray.push(`${strings.thursday} — ${thursdayTimings}`)
                timeArray.push(`${strings.friday} — ${fridayTimings}`)
            }
            timeArray.push(`${strings.saturday} — ${saturdayTimings}`)
            timeArray.push(`${strings.sunday} — ${sundayTimings}`)

            return timeArray
        }
        return null
    },

    saleHoursToString(time) {
        if (time == null || time.sale_hours == null) return ''

        let saleHoursStr = ''
        time.sale_hours.forEach(saleHour => {
            if (saleHoursStr !== '') saleHoursStr += ', '
            saleHoursStr += `${alcoholUtility.convertTimeFormat(
                saleHour.start_time
            )} ${strings.to} ${alcoholUtility.convertTimeFormat(saleHour.end_time)}`
        })

        return saleHoursStr
    },

    convertTimeFormat(time) {
        return moment(time, 'HHmm').format('hh:mm a')
    },

    getDayOfWeek(day) {
        switch (day) {
            case 0:
                return 'Sunday'
            case 1:
                return 'Monday'
            case 2:
                return 'Tuesday'
            case 3:
                return 'Wednesday'
            case 4:
                return 'Thursday'
            case 5:
                return 'Friday'
            case 6:
                return 'Saturday'
            default:
                return ''
        }
    },
}
